export enum ACTION_LIST {
  FETCH_RESIDENTIAL_COMPLEX = 'FETCH_RESIDENTIAL_COMPLEX',
  FETCH_SUGGESTION_LIST = 'FETCH_SUGGESTION_LIST'
}
